import { defineMessages } from 'react-intl';

export const itemsMessages = defineMessages({
  title: {
    id: 'items.title',
    defaultMessage: 'Items',
  },
  itemsWillAppear: {
    id: 'items.empty.items-will-appear',
    defaultMessage: 'Your items will appear here',
  },
  addItemToGetStarted: {
    id: 'items.empty.add-item-to-get-started',
    defaultMessage: 'Add an item to get started',
  },
  addItem: {
    id: 'items.button.add-item',
    defaultMessage: 'Add item',
  },
  duplicateItem: {
    id: 'items.settings.duplicate-item',
    defaultMessage: 'Duplicate item',
  },
  editItem: {
    id: 'items.settings.edit-item',
    defaultMessage: 'Edit item',
  },
  itemsLoadError: {
    id: 'items.load-error',
    defaultMessage: 'There was an error loading items. Please try again later.',
  },
  itemAvailabileUpdateSuccess: {
    id: 'items.item-availability-status.update-available-success',
    defaultMessage: '<strong>{itemName}</strong> marked available',
  },
  itemAvailableUpdateErrorTitle: {
    id: 'items.item-availability-status.update-available-error.title',
    defaultMessage: '<strong>We were unable to mark your item as available</strong>',
  },
  itemUnavailabileUpdateSuccess: {
    id: 'items.item-availability-status.update-unavailable-success',
    defaultMessage: '<strong>{itemName}</strong> marked unavailable',
  },
  itemUnavailableUpdateErrorTitle: {
    id: 'items.item-availability-status.update-uavailable-error.title',
    defaultMessage: '<strong>We were unable to mark your item as unavailable</strong>',
  },
  itemAvailabilityUpdateErrorDescription: {
    id: 'items.item-availability-status.update-error.description',
    defaultMessage:
      'Please check your connection and try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
});

export const itemsGroupMessages = defineMessages({
  otherCategory: {
    id: 'items.items-group.header.other',
    defaultMessage: 'Other',
  },
  payout: {
    id: 'items.items-group.header.payout',
    defaultMessage: 'Payout',
  },
  availability: {
    id: 'items.items-group.header.availability',
    defaultMessage: 'Item availability',
  },
  payoutTooltip: {
    id: 'items.items-group.header.payout-tooltip',
    defaultMessage:
      'Your payout is calculated based on your listed menu price for this item. For item tax clarifications, please see <a>here</a>.',
  },
  collapseCategoryAriaLabel: {
    id: 'items.items-group.button.collapse-category-aria-label',
    defaultMessage: 'Collapse category {categoryName}',
  },
  expandCategoryAriaLabel: {
    id: 'items.items-group.button.expand-category-aria-label',
    defaultMessage: 'Expand category {categoryName}',
  },
  editItemAriaLabel: {
    id: 'items.items-group.button.edit-item-aria-label',
    defaultMessage: 'Edit item {itemName}',
  },
  addItemAriaLabel: {
    id: 'items.items-group.button.add-item-aria-label',
    defaultMessage: 'Add item',
  },
  addItem: {
    id: 'items.items-group.button.add-item',
    defaultMessage: 'Add item',
  },
});

export const itemAvailabilityStatusMesages = defineMessages({
  itemStatusAvailable: {
    id: 'items.item-availability-status.available',
    defaultMessage: 'Available',
  },
  itemStatusUnavailableToday: {
    id: 'items.item-availability-status.unavailable-today',
    defaultMessage: 'Unavailable today',
  },
  itemStatusUnavailableIndefinitely: {
    id: 'items.item-availability-status.unavailable-indefinitely',
    defaultMessage: 'Unavailable indefinitely',
  },
  itemStatusPending: {
    id: 'items.item-availability-status.pending',
    defaultMessage: 'Pending review',
  },
});

export const venueOpenStatusMessages = defineMessages({
  venueStatusHidden: {
    id: 'items.venue-status.hidden',
    defaultMessage: 'Hidden on ClassPass',
  },
  venueStatusClosed: {
    id: 'items.venue-status.closed',
    defaultMessage: 'Closed for the day',
  },
  venueStatusOpen: {
    id: 'items.venue-status.open',
    defaultMessage: 'Open',
  },
  venueOpenStatusLoadError: {
    id: 'items.venue-status.load-error',
    defaultMessage: 'There was an error loading the venue open status. Please try again later.',
  },
  storeClosedSuccess: {
    id: 'items.venue-status.store-closed-success',
    defaultMessage: 'Your store is closed for today',
  },
  storeOpenSuccess: {
    id: 'items.venue-status.store-open-success',
    defaultMessage: 'Your store is open for today',
  },
  storeClosedErrorTitle: {
    id: 'items.venue-status.store-closed-error-title',
    defaultMessage: '<strong>We were unable to close your store</strong>',
  },
  storeOpenErrorTitle: {
    id: 'items.venue-status.store-open-error-title',
    defaultMessage: '<strong>We were unable to open your store</strong>',
  },
  storeClosedErrorDescription: {
    id: 'items.venue-status.store-closed-error-description',
    defaultMessage:
      'Please check your connection and try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
  storeOpenErrorDescription: {
    id: 'items.venue-status.store-open-error-description',
    defaultMessage:
      'Please check your connection and try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
});

export const settingsMessages = defineMessages({
  closedDates: {
    id: 'items.settings.closed-dates',
    defaultMessage: 'Add closed dates',
  },
  businessProfile: {
    id: 'items.settings.profile',
    defaultMessage: 'Business Profile',
  },
});
